module.exports = __webpack_public_path__ + "static/media/homokora3.108d05b5.jpg";